





















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import SettingsCategoryTypeForm from "./SettingsCategoryTypeForm.vue";

import SettingsJson from "../../shared/SettingsJson";
import ModulesJson from "../../shared/ModulesJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import { ValidationResult, Validation } from "../../shared/Validation";
import SettingsCategoryTypeFormVue from "./SettingsCategoryTypeForm.vue";

export default Vue.extend({
  name: "SettingsCategoryTypeDetails",
  components: {
    OverlayWindow,
    Loading,
    SettingsCategoryTypeForm,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    categoryTypeType: String as PropType<CategoryTypeType>,
    categoryTypeId: Number,
  },
  data() {
    return {
      detailsMode: "" as string,
      detailsTitle: "" as string,
      editable: false as boolean,
      loading: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.detailsMode = this.mode;
      this.selectDetailsMode(this.detailsMode);
    },

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Kategorie anlegen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Kategorie bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Kategorie";
          this.editable = false;
          break;
      }
    },
  },
  watch: {},
  computed: {},
});
